;(function () {
  'use strict'

  angular.module('contrast.compliance-report').constant('COMPLIANCE_REPORT', {
    DISA: {
      value: 'DISA',
      name: 'DISA ASD STIG'
    },
    OWASP_2013: {
      value: 'OWASP_2013',
      name: 'OWASP 2013 Top 10'
    },
    OWASP_2017: {
      value: 'OWASP_2017',
      name: 'OWASP 2017 Top 10'
    },
    PCI_2: {
      value: 'PCI_2',
      name: 'PCI DSS - 2.0'
    },
    PCI_3: {
      value: 'PCI_3',
      name: 'PCI DSS - 3.0'
    },
    PCI_3_2_1: {
      value: 'PCI_3_2_1',
      name: 'PCI DSS - 3.2.1'
    }
  })
})()
